/**
 * ActionButton - Botão de ação genérico com ícone SVG.
 * Usado no header e input do chat.
 */
import React from 'react';
import { AppIcon, IconName } from '../../../../components/icons/AppIcon';

interface ActionButtonProps {
    title: string;
    colorClass: string;
    iconName: IconName;
    onClick?: () => void;
    ariaLabel?: string;
    iconClassName?: string;
}

export const ActionButton: React.FC<ActionButtonProps> = ({ title, colorClass, iconName, onClick, ariaLabel, iconClassName = "w-5 h-5" }) => (
    <button
        type="button"
        title={title}
        onClick={onClick}
        className={`p-2 rounded-full transition-colors text-muted ${colorClass}`}
        aria-label={ariaLabel || title}
    >
        <AppIcon name={iconName} className={iconClassName} />
    </button>
);

